module.exports = __webpack_public_path__ + "img/logo.1dbb5970.gif";